import { useSyncExternalStore } from "react";

const subscribe = () => () => {}

// false au rendu serveur et pendant l'hydratation, true ensuite côté client
export const useHydrated = () => useSyncExternalStore(subscribe, () => true, () => false)
